jQuery( function( $ ) {
	
	var swatches = [];
	var $swatches = $('.swatch');
  	var $swatchCategories = $('.swatch-category');
  	var $selection = $('.swatches-selection');
  	var $selectionHeading = $('.swatches-selection h2');
  	var $status = $('.swatches-selection-status');
	var $preview = $('.swatches-selection-preview');
  	var $submit = $('.swatches-selection .submit');
	var $form = $('.swatches-selection form');
  	var $alert = $('.swatches-alert');
  	var selectionOffset = $('.swatches-container').offset().top;
  	var heading = '';
  	var lastHeading = $selectionHeading;
  	
  
	$('.swatch img').on('click', function(e) {
		
		$parent = $(this).parent().parent();
		
		if ($parent.hasClass('active')) {
			// Remove
			remove_swatch($parent.data('id'));
		} else {
			// Add
			add_swatch($parent.data('id'));
		}
	});

	function remove_swatch(id) {	
		
      	$alert.removeClass('active');
      
		swatches = swatches.filter(function(item) { 
			return item !== id
		});
				
		update();
	}
	
	function add_swatch(id) {	
		
		if (swatches.length == 6) {

          	$alert.addClass('active');
          
          	setTimeout(function() {
    			$alert.removeClass('active');
			}, 4000);
          
        } else {
          	$alert.removeClass('active');
			swatches.push(id);
			update();
		}
	}
	
	function update() {
		
		html = '';
      	ids = '';
		
		$swatches.removeClass('active');
		
		swatches.forEach(function(id) {
			
			src = $('.swatch[data-id=' + id +'] img').attr('src');
			
			html = html + '<li><img src="' + src + '" width="20" height="20"></li>';
			
          	ids = ids + '<input type="hidden" name="id[]" class="ids" value="' + id + '">';
          
			$('.swatch[data-id=' + id +']').addClass('active');
			
		});
      	
      	placeholders = 6 - swatches.length;
      
      	for (var i = 0; i < placeholders; i++) {
  			html = html + '<li></li>';         
        }
		
      	// Update Submit button
      	if (swatches.length > 0 ) {
      		$submit.removeAttr('disabled');
        } else {
      		$submit.attr('disabled', 'disabled');		
        }
		
		// Update Preview
		$preview.html(html);
		
		// Update count
		$status.html(swatches.length + ' / 6');
		
      	// Update IDs
      	$form.find('input.ids').remove();
      	$form.append(ids);
	}
		
 	// Fixed positioning
	// Listen for scroll
	$(window).on('scroll', function(e) {
		windowScrollTop = $(this).scrollTop();
		requestAnimationFrame(updateScroll);
	});

  
	function updateScroll() {		
		if (windowScrollTop > $('.swatches-container').offset().top) {
			$selection.addClass('fixed');	
          	
          	// Find active section   	
          	$swatchCategories.each(function(e) {
              
			  if ($(this).offset().top < windowScrollTop && ($(this).offset().top + $(this).height() > windowScrollTop) ) {                
               	heading = $(this).data('title');
                return false;
              }
            });
          	
          
          	if (lastHeading != heading || !lastHeading) {
          		$selectionHeading.text(heading);
          	}          	
          	lastHeading = heading;
          
		} else {
			$selection.removeClass('fixed');
          	$selectionHeading.text($selectionHeading.data('original'));
          	lastHeading = false;
		}			
	}  
});